import {
  GET_ADDON_PACKAGES_REQUEST,
  GET_ADDON_PACKAGES_SUCCESS,
  GET_ADDON_PACKAGES_FAIL,
  CREATE_ADDON_PACKAGE_REQUEST,
  CREATE_ADDON_PACKAGE_SUCCESS,
  CREATE_ADDON_PACKAGE_FAIL,
  UPDATE_ADDON_PACKAGE_REQUEST,
  UPDATE_ADDON_PACKAGE_SUCCESS,
  UPDATE_ADDON_PACKAGE_FAIL,
} from '../actions/types';

const initialState = {
  addonPackages: [],
  loading: false,
  error: null,
};

const addonPackageReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ADDON_PACKAGES_REQUEST:
    case CREATE_ADDON_PACKAGE_REQUEST:
    case UPDATE_ADDON_PACKAGE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

   // In your addonPackageReducer.js
case GET_ADDON_PACKAGES_SUCCESS:
  return { 
    ...state, 
    loading: false, 
    addonPackages: Array.isArray(action.payload) ? action.payload : []
  };

    case CREATE_ADDON_PACKAGE_SUCCESS:
      // Assuming action.payload is the newly created addon package object
      return {
        ...state,
        loading: false,
        addonPackages: [...state.addonPackages, action.payload],
        error: null,
      };

    case UPDATE_ADDON_PACKAGE_SUCCESS:
      // Assuming action.payload is the updated addon package object with an 'id'
      return {
        ...state,
        loading: false,
        addonPackages: state.addonPackages.map(pkg =>
          pkg.id === action.payload.id ? action.payload : pkg
        ),
        error: null,
      };

    case GET_ADDON_PACKAGES_FAIL:
    case CREATE_ADDON_PACKAGE_FAIL:
    case UPDATE_ADDON_PACKAGE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

// Change this to default export
export default addonPackageReducer;